import React from 'react';
import Icon from '@components/AppIcon';

const PageHeader = () => {
  return (
    <section
      className="relative pt-28 pb-20 md:pt-32 md:pb-28 min-h-[60vh] flex items-center"
      style={{
        backgroundImage: `url('/storage/gallery_images/slider-3.png')`, // Use your local image
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Navy overlay */}
      <div className="absolute inset-0 bg-blue-900/70"></div>

      {/* Content */}
      <div className="relative container mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Main Heading */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 drop-shadow-lg">
          Join Our Team
        </h1>

        {/* Subtitle */}
        <p className="text-lg md:text-xl lg:text-2xl text-white/95 max-w-3xl mx-auto mb-8 leading-relaxed drop-shadow-md">
          Join Kenya's most innovative eye care team where passion meets purpose. 
          We're creating the future of healthcare, one patient at a time.
        </p>

        {/* Info Highlights */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-10 text-white text-lg font-medium mt-2">
          <div className="flex items-center gap-2">
            <Icon name="MapPin" size={24} className="text-[#eb2227]" />
            <span>Nairobi, Kenya</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="Clock" size={24} className="text-[#eb2227]" />
            <span>Flexible Hours</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="Star" size={24} className="text-[#eb2227]" />
            <span>Growth Opportunities</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PageHeader;
